import * as CryptoJS from 'crypto-js';

const encrypted = (plainText: string, key: string, iv: string): string => {
  const keyHex = CryptoJS.enc.Hex.parse(key);
  const ivHex = CryptoJS.enc.Hex.parse(iv);

  return CryptoJS.AES.encrypt(plainText, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  } as any).toString();
};

const decrypted = (cipherText: string, key: string, iv: string) => {
  const keyHex = CryptoJS.enc.Hex.parse(key);
  const ivHex = CryptoJS.enc.Hex.parse(iv);
  return CryptoJS.AES.decrypt(cipherText, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  } as any).toString(CryptoJS.enc.Utf8);
};

const generateKey = () => {
  return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
};

const generateIv = () => {
  return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
};

export const AESUtil = {
  encrypted,
  generateKey,
  generateIv,
  decrypted,
};
